import { jsxs as I, jsx as s } from "react/jsx-runtime";
import { MessageActions as f, MessageType as g } from "../../helpers/daymaptypes.js";
import { useTitle as N } from "../../context/metadata/title.js";
import { Box as E, Collapse as P, Alert as S } from "@mui/material";
import { useState as m, useEffect as k } from "react";
import { RecipientPicker as w } from "./components/RecipientPicker.js";
import { C as A } from "../../index-DNTqwtVt.js";
const y = ({
  messageType: o,
  onMessageSent: h,
  messageProperties: p,
  initialRecipients: e = [],
  pageContainer: u = E,
  additionalContent: M,
  additionalValidation: n
}) => {
  N("New Message");
  const [t, c] = m([...e]), [r, a] = m();
  k(() => {
    e.length > 0 && t.length === 0 && c([...e]);
  }, [e, t]);
  const i = (l) => {
    c(l), r && r[0] === "NO_RECIPIENTS" && l.length > 0 && a(null);
  }, C = () => n && !n() ? !1 : o === g.Peer && t.length === 0 ? (a(["NO_RECIPIENTS", "Must select a recipient"]), !1) : !0, d = f.Send | f.Attach, x = e && e.length > 0;
  return /* @__PURE__ */ I(u, { sx: { display: "flex", flexFlow: "column", gap: 2 }, children: [
    M,
    o === g.Peer && /* @__PURE__ */ s(w, { contactIds: t, onChange: i, disabled: x }),
    r && /* @__PURE__ */ s(P, { in: !!r, children: /* @__PURE__ */ s(S, { severity: "error", children: r[1] }) }),
    /* @__PURE__ */ s(
      A,
      {
        actionsMask: d,
        onMessageSent: h,
        messageProperties: p,
        messageType: o,
        canSendCheck: C,
        contactIds: t
      }
    )
  ] });
};
export {
  y as NewMessageView
};
//# sourceMappingURL=NewMessageView.js.map
